<template>
    <div>
        <Navbar />
        <!-- <PageTitle
            pageTitle="Datenschutzerklärung"
            pageDesc="Informationen zum Schutz Ihrer Daten"
        /> -->
        <div class="legal-area ptb-100">
            <div class="container">
                <div class="legal-content">
                    <h3>Datenschutzerklärung</h3>
                    <p class="legal-subtitle">benovium.com</p>

                    <div class="legal-section">
                        <h4>1. Verantwortlicher</h4>
                        <p>
                            Verantwortlicher für die Datenverarbeitung auf dieser Website:
                        </p>
                        <p>
                            <strong>Benovium e.U.</strong><br>
                            Bernhard Wallner<br>
                            Antonigasse 44/5<br>
                            1180 Wien, Österreich<br>
                            E-Mail: <a href="mailto:office@benovium.com">office@benovium.com</a>
                        </p>
                    </div>

                    <div class="legal-section">
                        <h4>2. Überblick der Verarbeitungen</h4>
                        <p>
                            Diese Datenschutzerklärung informiert Sie über Art, Umfang und Zweck der Verarbeitung
                            personenbezogener Daten auf unserer Website gemäß der Datenschutz-Grundverordnung (DSGVO).
                        </p>
                    </div>

                    <div class="legal-section">
                        <h4>3. Hosting</h4>
                        <p>Unsere Website wird bei folgenden Anbietern gehostet:</p>
                        <ul>
                            <li>Netlify, Inc. (USA) - unter Verwendung von EU-Standardvertragsklauseln</li>
                            <li>Vercel, Inc. (USA) - unter Verwendung von EU-Standardvertragsklauseln</li>
                        </ul>
                        <p>Beim Besuch unserer Website werden automatisch technische Daten erfasst (Server-Logfiles):</p>
                        <ul>
                            <li>IP-Adresse (anonymisiert)</li>
                            <li>Datum und Uhrzeit der Anfrage</li>
                            <li>Browsertyp und -version</li>
                            <li>Betriebssystem</li>
                        </ul>
                        <p>
                            Rechtsgrundlage: Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an der technischen
                            Bereitstellung der Website).
                        </p>
                    </div>

                    <div class="legal-section">
                        <h4>4. Kontaktaufnahme</h4>
                        <p>
                            Wenn Sie uns per E-Mail oder Kontaktformular kontaktieren, werden Ihre Angaben zur
                            Bearbeitung der Anfrage verarbeitet und gespeichert.
                        </p>
                        <p>
                            <strong>Verarbeitete Daten:</strong> Name, E-Mail-Adresse, Nachrichteninhalt, ggf. Telefonnummer.
                        </p>
                        <p>
                            <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. b DSGVO (Vertragsanbahnung) bzw. Art. 6 Abs. 1 lit. f
                            DSGVO (berechtigtes Interesse an der Beantwortung von Anfragen).
                        </p>
                        <p>
                            <strong>Speicherdauer:</strong> Ihre Daten werden gelöscht, sobald sie für die Erreichung des Zweckes nicht
                            mehr erforderlich sind, spätestens jedoch 3 Jahre nach dem letzten Kontakt.
                        </p>
                    </div>

                    <div class="legal-section">
                        <h4>5. Cookies</h4>
                        <p>
                            Diese Website verwendet keine Cookies zu Tracking- oder Analysezwecken. Technisch
                            notwendige Cookies können vom Hosting-Provider gesetzt werden.
                        </p>
                    </div>

                    <div class="legal-section">
                        <h4>6. Ihre Rechte</h4>
                        <p>Sie haben folgende Rechte bezüglich Ihrer personenbezogenen Daten:</p>
                        <ul>
                            <li>Auskunft (Art. 15 DSGVO)</li>
                            <li>Berichtigung (Art. 16 DSGVO)</li>
                            <li>Löschung (Art. 17 DSGVO)</li>
                            <li>Einschränkung der Verarbeitung (Art. 18 DSGVO)</li>
                            <li>Datenübertragbarkeit (Art. 20 DSGVO)</li>
                            <li>Widerspruch (Art. 21 DSGVO)</li>
                        </ul>
                        <p>
                            Zur Ausübung Ihrer Rechte wenden Sie sich bitte an: <a href="mailto:office@benovium.com">office@benovium.com</a>
                        </p>
                    </div>

                    <div class="legal-section">
                        <h4>7. Beschwerderecht</h4>
                        <p>Sie haben das Recht, sich bei der zuständigen Aufsichtsbehörde zu beschweren:</p>
                        <p>
                            <strong>Österreichische Datenschutzbehörde</strong><br>
                            Barichgasse 40-42<br>
                            1030 Wien<br>
                            E-Mail: <a href="mailto:dsb@dsb.gv.at">dsb@dsb.gv.at</a><br>
                            Web: <a href="https://www.dsb.gv.at" target="_blank" rel="noopener">www.dsb.gv.at</a>
                        </p>
                    </div>

                    <div class="legal-section">
                        <h4>8. Dienste Dritter</h4>
                        <p>Wir setzen folgende externe Dienste ein:</p>
                        <p>
                            <strong>Google Workspace (E-Mail)</strong><br>
                            Anbieter: Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Irland<br>
                            Zweck: E-Mail-Kommunikation<br>
                            Datenschutzerklärung: <a href="https://policies.google.com/privacy" target="_blank" rel="noopener">https://policies.google.com/privacy</a>
                        </p>
                    </div>

                    <div class="legal-section">
                        <h4>9. Aktualität und Änderung dieser Datenschutzerklärung</h4>
                        <p>
                            Wir behalten uns vor, diese Datenschutzerklärung anzupassen, damit sie stets den aktuellen
                            rechtlichen Anforderungen entspricht.
                        </p>
                        <p><em>Stand: 13.1.2026</em></p>
                    </div>
                </div>
            </div>
        </div>
        <Footer :showDivider="true" />
    </div>
</template>

<script>
import { useHead } from '@vueuse/head';
import Navbar from '../Layouts/NavbarStyleTwo';
import PageTitle from '../Common/PageTitle';
import Footer from '../Layouts/Footer';

export default {
    name: 'DatenschutzPage',
    setup() {
        useHead({
            title: 'Datenschutzerklärung - Benovium',
            meta: [
                { name: 'description', content: 'Datenschutzerklärung von Benovium. Informationen zur Verarbeitung Ihrer personenbezogenen Daten gemäß DSGVO.' },
                { name: 'robots', content: 'noindex, follow' },
                { property: 'og:title', content: 'Datenschutzerklärung - Benovium' },
                { property: 'og:url', content: 'https://benovium.com/datenschutz' },
            ],
            link: [
                { rel: 'canonical', href: 'https://benovium.com/datenschutz' }
            ]
        });
    },
    components: {
        Navbar,
        PageTitle,
        Footer
    }
}
</script>

<style scoped>
.legal-area {
    background: #f8f9fa;
}

.legal-content {
    max-width: 800px;
    margin: 0 auto;
    background: #fff;
    padding: 40px;
    border-radius: 10px;
    box-shadow: 0 5px 30px rgba(0, 0, 0, 0.05);
}

.legal-content h3 {
    font-size: 28px;
    margin-bottom: 30px;
    padding-bottom: 15px;
    border-bottom: 2px solid #6a11cb;
}

.legal-section {
    margin-bottom: 30px;
}

.legal-section h4 {
    font-size: 18px;
    color: #1a1a2e;
    margin-bottom: 15px;
}

.legal-section p {
    color: #666;
    line-height: 1.8;
    margin-bottom: 15px;
}

.legal-section ul {
    color: #666;
    line-height: 1.8;
    margin-bottom: 15px;
    padding-left: 20px;
}

.legal-section ul li {
    margin-bottom: 5px;
}

.legal-section a {
    color: #6a11cb;
}

.legal-section a:hover {
    text-decoration: underline;
}

@media (max-width: 768px) {
    .legal-content {
        padding: 20px;
    }

    .legal-content h3 {
        font-size: 22px;
    }
}
</style>
